import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

interface LoginButtonProps {
  className?: string;
  onLoginSuccess?: () => void;
}

const Button = styled.button`
  background: var(--color-background-secondary);
  border: 1px solid var(--color-border-light);
  border-radius: 8px;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--color-text-primary);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: var(--color-background-hover);
    border-color: var(--color-border-medium);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
  
  svg {
    width: 18px;
    height: 18px;
    margin-right: 0.75rem;
    stroke-width: 2px;
  }
  
  @media (max-width: 768px) {
    padding: 0.5rem;
    
    svg {
      margin-right: 0;
    }
    
    span {
      display: none;
    }
  }
`;

const LoginButton: React.FC<LoginButtonProps> = ({ className, onLoginSuccess }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // Login default landing is the chat surface, not /desktop.
    navigate('/auth', { state: { returnUrl: '/' } });
  };

  return (
    <Button onClick={handleClick} className={className}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
        <polyline points="10 17 15 12 10 7" />
        <line x1="15" y1="12" x2="3" y2="12" />
      </svg>
      <span>login</span>
    </Button>
  );
};

export default LoginButton; 